import React from "react";
var __jsx = React.createElement;
/** ------- Import Dependencies ------- */
import stl from './Spacing.module.css';
var Spacing = function Spacing(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("section", {
    className: stl.spacing
  }, children);
};
export default Spacing;